import { React, useState } from 'react'
import { Link } from 'react-router-dom'
import { SiBinance } from 'react-icons/si'
import { ImCross } from "react-icons/im";
import FastMenu from './FastMenu'


export default function RemoveLiquidity() {

    const [Alert, setAlert] = useState(1)


    const [state, setstate] = useState(0)

    return (
        <div className="container pt-lg-5 pt-3">

            {Alert == 1 &&
                <div className="col-lg-6 mx-auto mb-4" >
                    <div className="card g-card px-lg-3 py-3">
                        <div className="card-body">
                            <div className="d-flex justify-content-end" style={{ marginTop: "-10px", marginRight: "-10px" }}>
                                <ImCross className="cross-icon fs-6 pointer" onClick={() => setAlert(0)} />
                            </div>
                            <div className="d-flex ">
                                <span>
                                    Tip: <span className="text-faded">By adding liquidity you'll earn interest from farms stake pool where you look your liquidty provider tokens (LP) </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            }

            <div className="d-flex justify-content-center align-items-center">
                <div className="ws-tabs">
                    <Link to='/swap' >Swap</Link>
                    <Link to='/liquidity' className="active">Liquidity</Link>
                    <Link to='/Bridge'>Bridge</Link>
                </div>
            </div>
            <div className="row mx-0 mt-4 justify-content-center">
                <div className="col-lg-6 px-0">
                    <div className="card g-card px-lg-3 py-3">
                        <div className="ws-tabs bg-transparent d-flex justify-content-center mt-3">
                            <Link to='/add-liquidity' >Add</Link>
                            <Link to='/find-liquidity' className="active">Remove</Link>
                        </div>
                        <div className="card-body">

                            <div className="d-flex justify-content-between  ">
                                <p className="mb-0">Remove Liquidity</p>
                                <div className="d-flex align-items-center">
                                    <span className="pe-2">Sounds</span>
                                    <label className="switch">
                                        <input type="checkbox" />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>

                            <div className="ws-exchange-card py-4  mt-3 active just-box p-3"  >
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="mb-0 fs-5">0%</p>
                                    <p className="mb-0 fs-5">100%</p>
                                </div>
                                <div className="progress-bar my-2 mb-4"></div>
                                <div className="row mx-0">
                                    <div className="col-3 px-0 pe-2 ps-0">
                                        <button className="harvest text-uppercase text-faded-3 w-100">25%</button>
                                    </div>
                                    <div className="col-3 px-0 pe-2">
                                        <button className="harvest text-uppercase text-faded-3 w-100">50%</button>
                                    </div>
                                    <div className="col-3 px-0 pe-2">
                                        <button className="harvest text-uppercase text-faded-3 w-100">75%</button>
                                    </div>
                                    <div className="col-3 px-0  pe-0">
                                        <button className="harvest text-uppercase text-faded-3 w-100">100%</button>
                                    </div>
                                </div>
                            </div>

                            <FastMenu/>
                            <div className="ws-exchange-card  mt-3 active just-box p-3"  >
                                <div className="d-flex justify-content-between align-items-center">

                                </div>
                                <div className="d-flex align-items-center justify-content-between pt-3 ">
                                    <div className="d-flex align-items-center">
                                        <span className=" text-faded text-uppercase text-small fw-600 ">1.32</span>
                                        <span className="  text-uppercase text-small fw-600 px-4">=</span>
                                        <span className=" text-faded text-uppercase text-small fw-600 ">500 busd</span>

                                    </div>
                                    <div className="d-flex align-items-center">
                                        <div className="coin-icon" >
                                            <SiBinance />
                                        </div>
                                        <p className="mb-0 ps-2 fs-5">BNB</p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-between border-bottom pb-4 pt-3 ">
                                    <div className="d-flex align-items-center">
                                        <span className=" text-faded text-uppercase text-small fw-600 ">1.32</span>
                                        <span className="  text-uppercase text-small fw-600 px-4">=</span>
                                        <span className=" text-faded text-uppercase text-small fw-600 ">500 busd</span>

                                    </div>
                                    <div className="d-flex align-items-center">
                                        <div className="coin-icon" >
                                            <SiBinance />
                                        </div>
                                        <p className="mb-0 ps-2 fs-5">BNB</p>
                                    </div>
                                </div>


                                <div className=" d-flex justify-content-center mt-3">
                                    <button  className="  btn-faded text-light py-2 col-lg-4 col-6 text-small text-center">Approve</button>
                                    <button  className=" btn-faded text-light  py-2 ms-2 col-lg-4 col-6 text-small text-center">Remove</button>
                                </div>

                            </div>
                            <div className="d-flex align-items-center justify-content-between py-4 border-bottom">
                                <div className="d-flex align-items-start flex-column">
                                    <span className=" text-small ">Slippage tolerance</span>
                                </div>
                                <div className="d-flex align-items-end flex-column">
                                    <div className="d-flex align-items-center">
                                    <input className="harvest text-uppercase text-faded-3 ms-2" defaultValue='0.1' style={{ width: "50px" }} />
                                        <input className="harvest text-uppercase text-faded-3 ms-2" defaultValue='0.6' style={{ width: "50px" }} />
                                        <input className="harvest text-uppercase text-faded-3 ms-2" defaultValue='1' style={{ width: "50px" }} />
                                        <input className="harvest text-uppercase text-faded-3 ms-2 me-2" defaultValue='0.00' style={{ width: "60px" }} />
                                        <span className=" text-small ">%</span>
                                    </div>
                                </div>

                            </div>
                            <span className=" text-small text-uppercase text-faded pt-3">recent transactions </span>
                            <div className="d-flex justify-content-center pt-4">
                                <button className="g-btn">Connect wallet</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
